import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Router } from '@angular/router';
import type { AuthGuardData } from 'keycloak-angular';
import { createAuthGuard } from 'keycloak-angular';
import { inject } from '@angular/core';

const hasRequiredRole = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  { grantedRoles }: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const requiredRoles = route.data['roles'];

  if (Array.isArray(requiredRoles) === false) {
    return Promise.resolve(false);
  }

  const hasRequiredRole = grantedRoles.realmRoles.some(r => requiredRoles.includes(r));
  return hasRequiredRole ? Promise.resolve(true) : Promise.resolve(inject(Router).parseUrl('/'));
};

export const roleGuard = createAuthGuard<CanActivateFn>(hasRequiredRole);
